
// import React, { useState } from 'react';
// import {
//     Input,
//     FormGroup,
//     Button,
//     Label, Col, Row

// } from "reactstrap";
// import { useNavigate } from 'react-router-dom';
// import { Field } from 'formik';

// const BulkNextRound = ({ nextRound, closeModal }) => {
//     const navigate = useNavigate();
//     const [interviewMode, setInterviewMode] = useState('');




//     return (
//         <div
//             style={{
//                 minWidth: '640px',
//                 borderRadius: '32px',
//                 backgroundColor: '#fff',
//                 boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
//                 padding: '32px',
//             }}
//         >


//             <p
//                 className='heading'
//                 style={{
//                     fontWeight: 700,
//                     fontSize: '24px',
//                     lineHeight: '28px',
//                     marginBottom: '24px'
//                 }}
//             >
//               Move to Next Round
//             </p>
//             {/* <Row className='  p-3 m-0 mt-1  data'>

//                 <Col size={6}><p className='info-head'>Candidate ID</p>
//                     <p className='info'>C-001</p>
//                     <p className='info-head'>Job Title</p>
//                     <p className='info'>Fullstack Developer</p>
//                     <p className='info-head'>Source </p>
//                     <p className='info'>Vendor </p>
//                 </Col>
//                 <Col size={6}
//                 >
//                     <p className='info-head'>Candidate Name</p>
//                     <p className='info'>Name</p>
//                     <p className='info-head'>Application ID</p>
//                     <p className='info'>----</p>
//                     <p className='info-head'>Applied On</p>
//                     <p className='info'>DD/MM/YYYY</p>

//                 </Col>

//             </Row> */}

//             <Row className='mt-4'>
//                 <Col>
//                     <FormGroup>
//                         <Label style={{
//                             color: "#344054",
//                             fontWeight: 500,
//                             fontSize: '14px',
//                             lineHeight: '20px',
//                             letterSpacing: '0%',
//                         }}>Screening Round</Label>
//                         <Input type='select' width="30px" style={{}}>
//                             <option value="">Select</option>
//                         </Input>
//                     </FormGroup>
//                 </Col>
//             </Row>
//             <Row className=''>
//                 <Col>
//                     <FormGroup>
//                         <Label style={{
//                             color: "#344054",
//                             fontWeight: 500,
//                             fontSize: '14px',
//                             lineHeight: '20px',
//                             letterSpacing: '0%',
//                         }}>Interviewer(s)</Label>
//                         <Input type='select' width="30px" style={{}}>
//                             <option value="">Select</option>
//                         </Input>
//                     </FormGroup>
//                 </Col>
//             </Row>
//             <Row className=''>
//                 <Col>
//                     <FormGroup>
//                         <Label style={{
//                             color: "#344054",
//                             fontWeight: 500,
//                             fontSize: '14px',
//                             lineHeight: '20px',
//                             letterSpacing: '0%',
//                         }}>Mode of Interview</Label>
//                         <Input 
//     type='select' 
//     value={interviewMode} 
//     onChange={(e) => setInterviewMode(e.target.value)}
// >
//     {/* <option value="">Select</option> */}
//     <option value="virtual">Virtual</option>
//     <option value="physical">Physical/ In-person</option>
// </Input>
//                     </FormGroup>
//                 </Col>
//             </Row>
//             {interviewMode=="virtual" ? (<Row className=''>
//                 <Col>
//                     <FormGroup>
//                         <Label style={{
//                             color: "#344054",
//                             fontWeight: 500,
//                             fontSize: '14px',
//                             lineHeight: '20px',
//                             letterSpacing: '0%',
//                         }}>Virtual Interview Source
//                         </Label>
//                         <Input type='select' width="30px" style={{}}>
//                         <option value="">Select</option>
//                         <option value="zoom">Zoom</option>
//                         <option value="google-meet">Google Meet</option>
//                         <option value="teams">Microsoft Teams</option>
//                         </Input>
//                     </FormGroup>
//                 </Col>
//             </Row>) :    
//             (<Row className=''>
//                 <Col>
//                     <FormGroup>
//                         <Label style={{
//                             color: "#344054",
//                             fontWeight: 500,
//                             fontSize: '14px',
//                             lineHeight: '20px',
//                             letterSpacing: '0%',
//                         }}>Location
//                         </Label>
//                         <Input type='text' width="30px" placeholder='Location'>
                           
//                         </Input>
//                     </FormGroup>
//                 </Col>
//             </Row>)}
         

//             <Row className=''>
//                 <Col>
//                     <FormGroup>
//                         <Label style={{
//                             color: "#344054",
//                             fontWeight: 500,
//                             fontSize: '14px',
//                             lineHeight: '20px',
//                             letterSpacing: '0%',
//                         }}>
//                            Interview Date & Time
//                         </Label>
//                         <Row>
//                             <Col>
//                                 <Input
//                                     type="date"
//                                     placeholder="DD-MM-YYYY"
//                                 />
//                             </Col>
                          
//                         </Row>
//                     </FormGroup>
//                 </Col>
//             </Row>
           
//                 <Row className= ' mt-2 d-flex justify-content-center align-items-center'>
// <Col md={4}><Label style={{
//                             color: "#344054",
//                             fontWeight: 500,
//                             fontSize: '14px',
//                             lineHeight: '20px',
//                             letterSpacing: '0%',
//                         }}>
//                          Candidate Name 1
//                         </Label></Col>
                   
         
                       
//                        <Col md={3}>
//                                 <Input
//                                     type="time"
//                                     placeholder="HH:MM"
//                                     style={{ display: 'flex', justifyContent: 'flex-end' }}
//                                 /></Col>
                                
                  
//                         <Col md={5}>  <Input
//                                     type="text"
//                                     placeholder="URL"
//                                 /></Col>
                          
//                </Row>
//                <Row className='mt-3 d-flex justify-content-center align-items-center'>
// <Col md={4}><Label style={{
//                             color: "#344054",
//                             fontWeight: 500,
//                             fontSize: '14px',
//                             lineHeight: '20px',
//                             letterSpacing: '0%',
//                         }}>
//                          Candidate Name 2
//                         </Label></Col>
                   
         
                       
//                        <Col md={3}>
//                                 <Input
//                                     type="time"
//                                     placeholder="HH:MM"
//                                     style={{ display: 'flex', justifyContent: 'flex-end'}}
//                                 /></Col>
                                
                  
//                         <Col md={5}>  <Input
//                                     type="text"
//                                     placeholder="URL"

//                                 /></Col>
                          
//                </Row>
                       
//                <Row className='mt-3 d-flex justify-content-center align-items-center'>
// <Col md={4}><Label style={{
//                             color: "#344054",
//                             fontWeight: 500,
//                             fontSize: '14px',
//                             lineHeight: '20px',
//                             letterSpacing: '0%',
//                         }}>
//                          Candidate Name 3
//                         </Label></Col>
                   
         
                       
//                        <Col md={3}>
//                                 <Input
//                                     type="time"
//                                     placeholder="HH:MM"
//                                     style={{ display: 'flex', justifyContent: 'flex-end'}}/></Col>
                                
                  
//                         <Col md={5}>  <Input
//                                     type="text"
//                                     placeholder="URL"
//                                 /></Col>
                          
//                </Row>
                       
                        
              
//             <Row className='mt-4'>
//                 <Col>
//                     <FormGroup className='d-flex gap-2 align-items: center'>
//                         <Input className='checkbox' type="checkbox" style={{ border: "1px solid #475467" }} />
//                         <Label style={{
//                             fontFamily: 'Inter, sans-serif',
//                             fontWeight: 500,
//                             fontSize: '14px',
//                             // lineHeight: '22px',
//                             // letterSpacing: '0%'
//                         }}>Send rejection email to candidates</Label>
//                     </FormGroup>
//                     <FormGroup className='d-flex gap-2 align-items: center'>
//                         <Input className='checkbox' type="checkbox" style={{ border: "1px solid #475467" }} />
//                         <Label style={{
//                             fontFamily: 'Inter, sans-serif',
//                             fontWeight: 500,
//                             fontSize: '14px',
//                             // lineHeight: '22px',
//                             // letterSpacing: '0%'
//                         }}>Do not notify candidates</Label>
//                     </FormGroup></Col>
//             </Row>

//             <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px' }}>
//                 <Button
//                     onClick={closeModal}
//                     style={{
//                         backgroundColor: 'white',
//                         color: '#006438',
//                         border: '1px solid #006438',
//                         borderRadius: '12px',
//                         marginRight: '16px',
//                         width: "128px"

//                     }}
//                 >
//                     Cancel
//                 </Button>
//                 <Button
//                     // onClick={handleContinue}
//                     style={{
//                         backgroundColor: '#006438',
//                         color: '#FFFFFF',
//                         borderRadius: '12px',
//                         width: "128px"
//                     }}
//                 >
//                     Submit
//                 </Button>
//             </div>


//         </div>
//     );
// };

// export default BulkNextRound;

import React, { useState } from 'react';
import {
    Input,
    FormGroup,
    Button,
    Label, Col, Row
} from "reactstrap";
import { useNavigate } from 'react-router-dom';

const BulkNextRound = ({ nextRound, closeModal }) => {
    const navigate = useNavigate();
    const [interviewMode, setInterviewMode] = useState('virtual');
    const [interviewURL, setInterviewURL] = useState(['', '', '']);
    const [interviewTime, setInterviewTime] = useState(['', '', '']);

    const handleURLChange = (index, value) => {
        const updated = [...interviewURL];
        updated[index] = value;
        setInterviewURL(updated);
    };

    const handleTimeChange = (index, value) => {
        const updated = [...interviewTime];
        updated[index] = value;
        setInterviewTime(updated);
    };

    return (
        <div style={{
            minWidth: '640px',
            borderRadius: '32px',
            backgroundColor: '#fff',
            boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
            padding: '32px',
        }}>
            <p className='heading' style={{ fontWeight: 700, fontSize: '24px', marginBottom: '24px' }}>
                Move to Next Round
            </p>

            <Row className='mt-4'>
                <Col>
                    <FormGroup>
                        <Label>Screening Round</Label>
                        <Input type='select'>
                            <option value="">Select</option>
                        </Input>
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col>
                    <FormGroup>
                        <Label>Interviewer(s)</Label>
                        <Input type='select'>
                            <option value="">Select</option>
                        </Input>
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col>
                    <FormGroup>
                        <Label>Mode of Interview</Label>
                        <Input
                            type='select'
                            value={interviewMode}
                            onChange={(e) => setInterviewMode(e.target.value)}
                        >
                            {/* <option value="">Select</option> */}
                            <option value="virtual">Virtual</option>
                            <option value="physical">Physical/ In-person</option>
                        </Input>
                    </FormGroup>
                </Col>
            </Row>

            {interviewMode === "virtual" ? (
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>Virtual Interview Source</Label>
                            <Input type='select'>
                                <option value="">Select</option>
                                <option value="zoom">Zoom</option>
                                <option value="google-meet">Google Meet</option>
                                <option value="teams">Microsoft Teams</option>
                            </Input>
                        </FormGroup>
                    </Col>
                </Row>
            ) : (
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>Location</Label>
                            <Input type='text' placeholder='Location' />
                        </FormGroup>
                    </Col>
                </Row>
            )}

            <Row>
                <Col>
                    <FormGroup>
                        <Label>Interview Date & Time</Label>
                        <Input type="date" placeholder="DD-MM-YYYY" />
                    </FormGroup>
                </Col>
            </Row>

            {/* {[1, 2, 3].map((_, index) => (
                <Row key={index} className='mt-3 d-flex align-items-center'>
                    <Col md={4}>
                        <Label>Candidate Name {index + 1}</Label>
                    </Col>
                    <Col md={3}     style={{display:"flex",justifyContent:"flex-end"}}>
                        <Input
                            type="time"
                            value={interviewTime[index]}
                            onChange={(e) => handleTimeChange(index, e.target.value)}
                        //  style={{display:"flex",justifyContent:"flex-end"}}
                        />
                    </Col>
                    {interviewMode === "virtual" && (
                        <Col md={5}>
                            <Input
                                type="text"
                                placeholder="URL"
                                value={interviewURL[index]}
                                onChange={(e) => handleURLChange(index, e.target.value)}
                                // style={{display:"flex",justifyContent:"flex-end"}}
                            />
                        </Col>
                    )}
                </Row>
            ))} */}

{[1, 2, 3].map((_, index) => (
    <Row key={index} className='mt-3 align-items-center'>
        <Col md={4}>
            <Label>Candidate Name {index + 1}</Label>
        </Col>

        {interviewMode === "virtual" ? (
            <>
                <Col md={3}>
                    <Input
                        type="time"
                        value={interviewTime[index]}
                        onChange={(e) => handleTimeChange(index, e.target.value)}
                    />
                </Col>
                <Col md={5}>
                    <Input
                        type="text"
                        placeholder="URL"
                        value={interviewURL[index]}
                        onChange={(e) => handleURLChange(index, e.target.value)}
                    />
                </Col>
            </>
        ) : (
            <Col md={{ size: 3, offset: 5 }} className="d-flex justify-content-end">
                <Input
                    type="time"
                    value={interviewTime[index]}
                    onChange={(e) => handleTimeChange(index, e.target.value)}
                    style={{ width: '100%' }}
                />
            </Col>
        )}
    </Row>
))}


            <Row className='mt-4'>
                <Col>
                    <FormGroup className='d-flex gap-2 align-items: center'>
                        <Input className='checkbox' type="checkbox" style={{ border: "1px solid #475467" }} />
                        <Label style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '22px',
                            // letterSpacing: '0%'
                        }}>Send rejection email to candidates</Label>
                    </FormGroup>
                    <FormGroup className='d-flex gap-2 align-items: center'>
                        <Input className='checkbox' type="checkbox" style={{ border: "1px solid #475467" }} />
                        <Label style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '22px',
                            // letterSpacing: '0%'
                        }}>Do not notify candidates</Label>
                    </FormGroup></Col>
            </Row>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px' }}>
                <Button
                    onClick={closeModal}
                    style={{
                        backgroundColor: 'white',
                        color: '#006438',
                        border: '1px solid #006438',
                        borderRadius: '12px',
                        marginRight: '16px',
                        width: "128px"
                    }}
                >
                    Cancel
                </Button>
                <Button
                    // onClick={handleContinue}
                    style={{
                        backgroundColor: '#006438',
                        color: '#FFFFFF',
                        borderRadius: '12px',
                        width: "128px"
                    }}
                >
                    Submit
                </Button>
            </div>
        </div>
    );
};

export default BulkNextRound;
